import { Observable } from '../Observable.js';
export class InputHandler {
    constructor(_execution_object, initial_interaction_objects) {
        this._execution_object = _execution_object;
        this._click_observable = new Observable();
        this._secondary_click_observable = new Observable();
        this._drag_begin_observable = new Observable();
        this._drag_observable = new Observable();
        this._drag_end_observable = new Observable();
        this._pointer_enter_observable = new Observable();
        this._pointer_leave_observable = new Observable();
        this._input_handler_updated = new Observable();
        this._input_handler_disposed = new Observable();
        this.enabled = true;
        this._interaction_objects = [...initial_interaction_objects];
    }
    dispose() {
        this._click_observable.dispose();
        this._secondary_click_observable.dispose();
        this._drag_begin_observable.dispose();
        this._drag_observable.dispose();
        this._drag_end_observable.dispose();
        this._pointer_enter_observable.dispose();
        this._pointer_leave_observable.dispose();
        this._input_handler_disposed.notify(this._execution_object, this._interaction_objects);
    }
    get execution_object() {
        return this._execution_object;
    }
    set interaction_objects(objects) {
        this._interaction_objects.length = 0;
        for (let i = 0; i < objects.length; i++) {
            this._interaction_objects.push(objects[i]);
        }
    }
    get interaction_objects() {
        return this._interaction_objects;
    }
    add_interaction_object(object) {
        this._interaction_objects.push(object);
        this._input_handler_updated.notify(this._execution_object, this._interaction_objects);
    }
    remove_interaction_object(object) {
        const index = this._interaction_objects.indexOf(object);
        if (index !== -1) {
            this._interaction_objects.splice(index, 1);
            this._input_handler_updated.notify(this._execution_object, this._interaction_objects);
        }
    }
    get input_handler_updated() {
        return this._input_handler_updated;
    }
    get input_handler_disposed() {
        return this._input_handler_disposed;
    }
    get click_observable() {
        return this._click_observable;
    }
    get secondary_click_observable() {
        return this._secondary_click_observable;
    }
    get drag_begin_observable() {
        return this._drag_begin_observable;
    }
    get drag_observable() {
        return this._drag_observable;
    }
    get drag_end_observable() {
        return this._drag_end_observable;
    }
    get pointer_enter_observable() {
        return this._pointer_enter_observable;
    }
    get pointer_leave_observable() {
        return this._pointer_leave_observable;
    }
}
//# sourceMappingURL=InputHandler.js.map